(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ViewEventController', ViewEventController);

  function ViewEventController($state, $stateParams, formErrorsService, eventService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.event = {};
    vm.sessionService = sessionService;

    activate();

    function activate() {
      getEvent();
    }

    function getEvent() {
      eventService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.event = response);
    }
  }
})();
